import { render, staticRenderFns } from "./BottleLess.vue?vue&type=template&id=797587ba&"
import script from "./BottleLess.vue?vue&type=script&lang=js&"
export * from "./BottleLess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports